import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { formatTitle } from '../components/document-title/DocumentTitle';
import { getTableDisplayName } from 'tdr-common';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { TableGuardOutletContext } from '../routes/TableGuard';
import { AvailabilityGuardContext } from '../routes/AvailabilityGuard';
import TableDrawer from '../components/table-drawer/TableDrawer';

export const TableDetailsPage = () => {
	const { table, restaurant } = useOutletContext<TableGuardOutletContext>();
	const { searchFilters } = useOutletContext<AvailabilityGuardContext>();

	const venueName = restaurant?.displayName ?? restaurant?.name;
	const tableName = getTableDisplayName(table);
	useDocumentTitle(formatTitle(tableName, venueName));

	return <TableDrawer selectedTable={table} restaurant={restaurant} searchFilters={searchFilters} />;
};
